/* eslint no-console: "off" */
import common from '../common';

export default {
  setAddOnGameDataSuccess(state, payload) {
    state.addOnGameData.success = payload.success;
  },
  setAddOnGameData(state, payload) {
    state.addOnGameData.gameId = payload.gameId;
    state.addOnGameData.correctAnswers = payload.correctAnswers;
    state.addOnGameData.payOutPoints = payload.payOutPoints;
    state.addOnGameData.riskPoints = payload.riskPoints;
  },
  resetAddOnGameData(state) {
    state.addOnGameData.success = false;
    state.addOnGameData.gameId = null;
    state.addOnGameData.correctAnswers = null;
    state.addOnGameData.payOutPoints = 0;
    state.addOnGameData.riskPoints = 0;
  },
  setBonusAddOnGameDataSuccess(state, payload) {
    state.addOnBonusGameData.success = payload.success;
  },
  setBonusAddOnGameDataFromAchievements(state, payload) {
    state.addOnBonusGameData.achievementName = payload;
  },
  setBonusAddOnGamePrize(state, payload) {
    state.addOnBonusGameData.prizeType = payload;
  },
  setBonusAddOnGameData(state, payload) {
    state.addOnBonusGameData.gameId = payload.gameId;
    state.addOnBonusGameData.correctAnswers = payload.correctAnswers;
    state.addOnBonusGameData.prizeType = payload.prizeType;
    state.addOnBonusGameData.gameType = payload.gameType;
    state.addOnBonusGameData.achievementName = payload.achievementName;
  },
  resetBonusAddOnGameData(state) {
    state.addOnBonusGameData.success = false;
    state.addOnBonusGameData.gameId = null;
    state.addOnBonusGameData.prizeType = null;
    state.addOnBonusGameData.gameType = null;
    state.addOnBonusGameData.achievementName = null;
  },
  setChallengePending(state, challengePending) {
    state.challengePending = challengePending;
  },
  updateValidRedirectionToPendingRequestPage(state, payload) {
    state.validRedirectionToPendingRequestPage = payload;
  },
  setToDefaultChallengeInfo(state) {
    state.challengeInfo.challengingStickerIcon = null;
    state.challengeInfo.challengedMsisdn = null;
    state.challengeInfo.challengingMsisdn = null;
    state.challengeInfo.challengedUsername = null;
    state.challengeInfo.challengingUsername = null;
    state.challengeInfo.challengedLevel = null;
    state.challengeInfo.challengingLevel = null;
    state.challengeInfo.challengedAvatar = null;
    state.challengeInfo.challengingAvatar = null;
    state.challengeInfo.forRematchHomeScore = null;
    state.challengeInfo.forRematchAwayScore = null;
    state.challengeInfo.forRematchIsHome = null;
    state.challengeInfo.isBot = false;
  },
  updateChallengeInfo(state, payload) {
    state.challengeInfo.challengingStickerIcon = (!payload.challengingStickerIcon) ? null : payload.challengingStickerIcon;
    state.challengeInfo.challengedMsisdn = payload.challengedMsisdn;
    state.challengeInfo.challengingMsisdn = payload.challengingMsisdn;
    state.challengeInfo.challengedUsername = payload.challengedUsername;
    state.challengeInfo.challengingUsername = payload.challengingUsername;
    state.challengeInfo.challengedAvatar = payload.challengedAvatar;
    state.challengeInfo.challengingAvatar = payload.challengingAvatar;
    state.challengeInfo.challengedLevel = payload.challengedLevel;
    state.challengeInfo.challengingLevel = payload.challengingLevel;
    state.challengeInfo.forRematchHomeScore = payload.forRematchHomeScore;
    state.challengeInfo.forRematchAwayScore = payload.forRematchAwayScore;
    state.challengeInfo.forRematchIsHome = payload.forRematchIsHome; // because the opponent challenge and so the home attribute refer to opponent
    state.challengeInfo.opponentIsBot = payload.opponentIsBot;
  },
  setGameDTOForResumeGameOnly(state, gameStateEnumForResumeGame) {
    state.gameStateEnumForResumeGame = gameStateEnumForResumeGame;
  },
  storeNumberOfQuestionsPerRound(state, payload) {
    state.numberOfQuestionsPerRound = payload.value;
  },
  setTransitionOnlyForSearchingToOpponent(state, value) {
    state.transitionOnlyForSearchingToOpponent = value;
  },
  setGamePending(state, gamePending) {
    state.gamePending = gamePending;
  },
  setGameInProgress(state, gameInProgress) {
    state.gameInProgress = gameInProgress;
  },
  setGameResuming(state, gameIsResuming) {
    state.gameIsResuming = gameIsResuming;
  },
  setGameID(state, gameID) {
    state.gameID = gameID;
  },
  setPlayersDetails(state, payload) {
    // set home player data
    state.playersDetails.homePlayerMSISDN = payload.homePlayerMSISDN;
    state.playersDetails.homePlayerUsername = payload.homePlayerUsername;
    state.playersDetails.homePlayerAvatar = payload.homePlayerAvatar;
    state.playersDetails.homePlayerLevel = payload.homePlayerLevel;
    // set away player data
    state.playersDetails.awayPlayerMSISDN = payload.awayPlayerMSISDN;
    state.playersDetails.awayPlayerUsername = payload.awayPlayerUsername;
    state.playersDetails.awayPlayerAvatar = payload.awayPlayerAvatar;
    state.playersDetails.awayPlayerLevel = payload.awayPlayerLevel;
  },
  increaseCurrentRoundNumberbyOne(state) {
    if (state.currentRoundNumber < 5) {
      state.currentRoundNumber += 1;
      console.log(`setting currentRoundNumber to ${state.currentRoundNumber}`);
    }
  },
  setCurrentRoundNumber(state, currentRoundNumber) {
    state.currentRoundNumber = currentRoundNumber;
    console.log(`setting currentRoundNumber to ${state.currentRoundNumber}`);
  },
  setCurrentQuestionNumber(state, currentQuestionNumber) {
    state.currentQuestionNumber = currentQuestionNumber;
    console.log(`setting currentQuestionNumber to ${state.currentQuestionNumber}`);
  },
  setPlayersCurrentThemes(state, payload) {
    state.homePlayerCurrentThemes = payload.homePlayerCurrentThemes;
    state.awayPlayerCurrentThemes = payload.awayPlayerCurrentThemes;
  },
  setCurrentThemeChooserMSISDN(state) {
    state.currentThemeChooserMSISDN = state.currentRoundNumber % 2 === 1 ? state.playersDetails.homePlayerMSISDN : state.playersDetails.awayPlayerMSISDN;
  },
  setPlayersCurrentSelectedTheme(state, payload) {
    state.homePlayerCurrentSelectedTheme = payload.homePlayerCurrentSelectedTheme;
    state.awayPlayerCurrentSelectedTheme = payload.awayPlayerCurrentSelectedTheme;
  },
  setPlayersCurrentQuestionDTOs(state, payload) {
    state.homePlayerQuestionDTO = payload.homePlayerQuestionDTO;
    state.awayPlayerQuestionDTO = payload.awayPlayerQuestionDTO;
  },
  setPlayersHelpsUsedStatus(state, payload) {
    state.homePlayerCheatHelpUsed = payload.homePlayerCheatHelpUsed;
    state.homePlayerFiftyFiftyHelpUsed = payload.homePlayerFiftyFiftyHelpUsed;
    state.awayPlayerCheatHelpUsed = payload.awayPlayerCheatHelpUsed;
    state.awayPlayerFiftyFiftyHelpUsed = payload.awayPlayerFiftyFiftyHelpUsed;
  },
  setHomePlayerAnswer(state, homePlayerAnswer) {
    state.homePlayerAnswer = homePlayerAnswer;
  },
  setAwayPlayerAnswer(state, awayPlayerAnswer) {
    state.awayPlayerAnswer = awayPlayerAnswer;
  },
  setCorrectAnswerID(state, correctAnswerID) {
    state.correctAnswerID = correctAnswerID;
  },
  resetPlayersAnswersHistoryCSSClasses(state) {
    state.homePlayerCorrectAnswersCSSClasses = [];
    state.awayPlayerCorrectAnswersCSSClasses = [];
  },
  updatePlayersAnswersHistoryCSSClasses(state, payload) {
    state.homePlayerCorrectAnswersCSSClasses = payload.homePlayerCorrectAnswersCSSClasses;
    state.awayPlayerCorrectAnswersCSSClasses = payload.awayPlayerCorrectAnswersCSSClasses;
  },
  setHomePlayerRoundAnswerTime(state, homePlayerRoundAnswerTime) {
    state.homePlayerRoundAnswerTime = homePlayerRoundAnswerTime;
  },
  setAwayPlayerRoundAnswerTime(state, awayPlayerRoundAnswerTime) {
    state.awayPlayerRoundAnswerTime = awayPlayerRoundAnswerTime;
  },
  setPlayersCurrentRoundScores(state, payload) {
    state.homePlayerRoundScore = payload.homePlayerRoundScore;
    state.awayPlayerRoundScore = payload.awayPlayerRoundScore;
  },
  setCurrentRoundWinner(state, payload) {
    state.currentRoundWinnerMSISDN = payload.isHomePlayerWinner && !payload.isAwayPlayerWinner ? state.playersDetails.homePlayerMSISDN : state.playersDetails.awayPlayerMSISDN;
    state.currentRoundWinnerUsername = payload.isHomePlayerWinner && !payload.isAwayPlayerWinner ? state.playersDetails.homePlayerUsername : state.playersDetails.awayPlayerUsername;
  },
  setGameFinishedStatus(state, gameFinished) {
    state.gameFinished = gameFinished;
  },
  setGameWinner(state, payload) {
    state.gameWinnerMSISDN = payload.gameWinnerMSISDN;
    state.gameWinnerUsername = payload.gameWinnerUsername;
  },
  setUserLeveledUp(state, userLeveledUp) {
    state.userLeveledUp = userLeveledUp;
  },
  setPlayersPostGameData(state, payload) {
    // store home player post game data
    state.homePlayerCorrectAnswersPoints = payload.homePlayerCorrectAnswersPoints;
    state.homePlayerRoundVictoriesPoints = payload.homePlayerRoundVictoriesPoints;
    state.homePlayerGameVictoryPoints = payload.homePlayerGameVictoryPoints;
    state.homePlayerTotalEarnedPoints = payload.homePlayerTotalEarnedPoints;
    state.homePlayerLevelUpBonusPoints = payload.homePlayerLevelUpBonusPoints;
    state.homePlayerCurrentLevel = payload.homePlayerCurrentLevel;
    state.homePlayerGameWinsToLevelUp = payload.homePlayerGameWinsToLevelUp;
    state.homePlayerGamesWon = payload.homePlayerGamesWon;
    state.homePlayerLevel = payload.homePlayerLevel;
    // store away player post game data
    state.awayPlayerCorrectAnswersPoints = payload.awayPlayerCorrectAnswersPoints;
    state.awayPlayerRoundVictoriesPoints = payload.awayPlayerRoundVictoriesPoints;
    state.awayPlayerGameVictoryPoints = payload.awayPlayerGameVictoryPoints;
    state.awayPlayerTotalEarnedPoints = payload.awayPlayerTotalEarnedPoints;
    state.awayPlayerLevelUpBonusPoints = payload.awayPlayerLevelUpBonusPoints;
    state.awayPlayerCurrentLevel = payload.awayPlayerCurrentLevel;
    state.awayPlayerGameWinsToLevelUp = payload.awayPlayerGameWinsToLevelUp;
    state.awayPlayerGamesWon = payload.awayPlayerGamesWon;
    state.awayPlayerLevel = payload.awayPlayerLevel;
    state.homePlayerGamesEarned = payload.homePlayerGamesEarned;
    state.awayPlayerGamesEarned = payload.awayPlayerGamesEarned;
  },
  resetGameState(state) {
    state.gamePending = false;
    state.gameInProgress = false;
    state.gameIsResuming = false;
    state.gameID = null;
    state.playersDetails.homePlayerMSISDN = '';
    state.playersDetails.homePlayerUsername = '';
    state.playersDetails.homePlayerAvatar = null;
    state.playersDetails.homePlayerLevel = 0;
    state.playersDetails.awayPlayerMSISDN = '';
    state.playersDetails.awayPlayerUsername = '';
    state.playersDetails.awayPlayerAvatar = null;
    state.playersDetails.awayPlayerLevel = 0;
    state.currentThemeChooserMSISDN = '';
    state.currentRoundNumber = 1;
    state.finalRoundNumber = common.state.lastRandomRound;
    state.currentQuestionNumber = 0;
    state.correctAnswerID = -1;
    state.currentRoundWinnerMSISDN = '';
    state.currentRoundWinnerUsername = '';
    state.gameFinished = false;
    state.gameWinnerMSISDN = '';
    state.gameWinnerUsername = '';
    state.userLeveledUp = false;
    state.homePlayerCurrentThemes = [];
    state.homePlayerCurrentSelectedTheme = null;
    state.homePlayerFiftyFiftyHelpUsed = false;
    state.homePlayerCheatHelpUsed = false;
    state.homePlayerAnswer = '';
    state.homePlayerQuestionAnswerTime = 0;
    state.homePlayerRoundAnswerTime = 0;
    state.homePlayerCorrectAnswersCSSClasses = [];
    state.homePlayerRoundIsWinner = false;
    state.homePlayerRoundScore = 0;
    state.homePlayerCorrectAnswersPoints = 0;
    state.homePlayerRoundVictoryPoints = 0;
    state.homePlayerGameVictoryPoints = 0;
    state.homePlayerTotalEarnedPoints = 0;
    state.homePlayerLevelUpBonusPoints = 0;
    state.awayPlayerCurrentThemes = [];
    state.awayPlayerCurrentSelectedTheme = null;
    state.awayPlayerFiftyFiftyHelpUsed = false;
    state.awayPlayerCheatUsed = false;
    state.awayPlayerAnswer = '';
    state.awayPlayerQuestionAnswerTime = 0;
    state.awayPlayerRoundAnswerTime = 0;
    state.awayPlayerCorrectAnswersCSSClasses = [];
    state.awayPlayerAnswerTime = 0;
    state.awayPlayerRoundIsWinner = false;
    state.awayPlayerRoundScore = 0;
    state.awayPlayerCorrectAnswersPoints = 0;
    state.awayPlayerRoundVictoryPoints = 0;
    state.awayPlayerGameVictoryPoints = 0;
    state.awayPlayerTotalEarnedPoints = 0;
    state.awayPlayerLevelUpBonusPoints = 0;
  },
  storeRegistrationPoints(state, points) {
    state.registrationPoints = points;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/mutations.js